function removeHash() {
  history.pushState("", document.title, window.location.pathname
    + window.location.search);
}

function initLinks($) {
  function updateLinks() {
    const { hash } = window.location
    const activeClass = 'company-archive__side-link--active'

    $('.company-archive__side-link').removeClass(activeClass)

    if (hash !== '#/') {
      $(`${hash}-link`).addClass(activeClass)
    }
  }

  updateLinks()

  $(window).on('hashchange', updateLinks)

  $('.company-archive__mobile-heading a:first-child').on('click', function() {
    const x1 = $(this).offset().top
    const originalScroll = $(window).scrollTop()
    const originalOffset = x1 - originalScroll;

    const interval = setInterval(() => {
      const x2 = $(this).offset().top
      const newOffset = x2 - originalOffset
      $(document).scrollTop(newOffset);
    }, 0)

    setTimeout(() => {
      clearInterval(interval)
    }, 150)
  })
}

function initFilters($) {
  $(".archive-filter__control").on('change', function(e) {
    $("select.archive-filter__control").each(function() {
      if ($(this).css('display') === 'none') {
        $(this).prop('disabled', true)
      } else {
        $("input.archive-filter__control").prop('disabled', true)
      }
    })

    removeHash()

    $(this).parents('form').submit();
  })

  $(".archive-filter__select")
    .on('focus', function() {
      $(this)
        .parents('.archive-filter')
        .find('.archive-filter__label')
        .addClass('active')
    })
    .on('blur', function() {
      $(this)
        .parents('.archive-filter')
        .find('.archive-filter__label')
        .removeClass('active')
    })

  $(window).on('resize', function() {
    $(".archive-filter__dropdown-radio, .archive-filter__select")
      .prop('disabled', false)
  })
}

const allTaxes = {
  sector: 'sectors',
  geography: 'geographies',
  category: 'category',
  exit: 'exits',
}

function removeTax(tax, $) {
  Object.keys(allTaxes).forEach(key => {
    if (allTaxes[key] !== tax) {
      $(`*[name="${key}"]`).first().prop('disabled', true)
    } else {
      $(`*[name="${key}"]`).prop('disabled', true)
    }
  })

  removeHash()

  $('.team-member-archive-filters').submit()
}


jQuery(($) => {
  initFilters($)

  if ($('body.post-type-archive-company').length > 0) {
    initLinks($)

    const hasNoHash = () => !window.location.hash
      || window.location.hash === ''
      || window.location.hash === '#/'

    const selectFirstCompany = () => {
      if (hasNoHash() && $(window).width() > 768) {
        window.location.hash = $('.company-archive__target').attr('id')
      }
    }

    selectFirstCompany()

    $(window).on('resize', selectFirstCompany)
  }

  $('.active-filter__remove-button').on('click', function() {
    const parent = $(this).parent()
    const tax = parent.find('.active-filter__tax').val()

    removeTax(tax, $)
  })
})



// WEBPACK FOOTER //
// ./scripts/pages/archive-filters.js